
/** Transaction-type keys used inside `store.billFormats`. */
export const BILL_FORMAT_TYPES = {
  SALES: 'sales',
  SALES_RETURN: 'sales_return',
  SALES_ORDER: 'sales_order',
  PURCHASE: 'purchase',
  PURCHASE_RETURN: 'purchase_return',
  ISSUE_PARTY: 'issue_party',
  ISSUE_KARIGAR: 'issue_karigar',
  ISSUE_REFINE: 'issue_refine',
  RECEIVE_PARTY: 'receive_party',
  RECEIVE_KARIGAR: 'receive_karigar',
  RECEIVE_REFINE: 'receive_refine',
};

/** The store flagged `isDefault`, falling back to the first one. */
export const getDefaultStore = (stores) =>
  stores?.find((store) => store?.isDefault) || stores?.[0] || null;

export const getDefaultStoreId = (stores) =>
  getDefaultStore(stores)?.referenceId ?? null;

export const getStoreById = (stores, storeId) =>
  stores?.find((store) => store?.referenceId === storeId) || null;

/**
 * Human readable label for a format — e.g. `{ prefix: 's-', suffix: '-82/83' }`
 * reads as `s--82/83`.
 */
export const formatBillFormatLabel = (format) =>
  `${format?.prefix || ''}${format?.suffix || ''}`;

export const getBillFormatList = (stores, storeId, transactionType) => {
  const store = getStoreById(stores, storeId);
  const formats = store?.billFormats?.[transactionType] ?? [];

  return formats.map((format, index) => ({
    billFormatId: format?.referenceId,
    billName: formatBillFormatLabel(format),
    prefix: format?.prefix ?? '',
    suffix: format?.suffix ?? '',
    isDefault: index === 0,
  }));
};


export const resolveBillFormatId = (formatList, currentBillFormatId) => {
  const isStillValid = formatList?.some(
    (item) => item?.billFormatId === currentBillFormatId,
  );

  return isStillValid
    ? currentBillFormatId
    : (formatList?.[0]?.billFormatId ?? null);
};
